import CARTDIALOG_TMPL from '@page/cart/js/cartDialogTmpl';
import AlertDialog from '@global/helpers/alertDialog';
import NewImage from '@global/components/global/image';
import messageBox from '@global/helpers/messageBox';
import ArrivalNotice from '@global/components/product_vue/ArrivalNotice_vue'; // 索取到貨通知
import gtmTrace from '@global/components/tracing/gtm';
import utmKDetect from '@global/helpers/utmKDetect';
import store from '@global/components/store/index';
import { createNamespacedHelpers } from 'vuex';
import { fireAddToCart } from '@global/gtm/common';
import axios from 'axios';

const { mapActions } = createNamespacedHelpers('miniCartModule');

export default {
  template: `<div>${CARTDIALOG_TMPL}</div>`,
  data() {
    return {
      alldatas: {},
      selectedID: null,
      selected: {},
      hasstock: true,
      isopen: false,
      selectedSpec: null,
      selectedSpecID: null,
      selectedSpecKey: null,
      counter: 1,
      btnStyle: 'disabled',
      btnDescription: this.btndescription.genernal,
      checkisopen: false,
      dataisload: false,
      openArrivalNotice: false,
      itemSpecInfo: '',
    };
  },
  store,
  components: { NewImage, ArrivalNotice },
  props: ['isnotice', 'btndescription'],
  computed: {
    btnStyleGenerate: {
      get() {
        if (this.alldatas.IsPreShow) {
          this.btnStyle = 'disabled';
        } else if (!this.hasstock) {
          this.btnStyle = 'disabled';
        }

        return this.btnStyle;
      },
      set(newVal) {
        this.btnStyle = newVal;
      },
    },
    btnDescriptionGenerate: {
      get() {
        if (this.alldatas.IsPreShow) {
          this.btnDescription = this.btndescription.preShow;
        } else if (this.isnotice && !this.hasstock) {
          this.btnDescription = this.btndescription.notice;
        } else if (!this.hasstock) {
          this.btnDescription = this.btndescription.soldout;
        }

        return this.btnDescription;
      },
      set(newVal) {
        this.btnDescription = newVal;
      },
    },
  },
  watch: {
    selectedID() {
      this.getSelectedData();
    },
  },
  methods: {
    ...mapActions(['getCartInfo']),
    closeArrivalNotice() {
      this.openArrivalNotice = false;
    },
    checkHasStock() {
      var _this = this;
      _this.hasstock = false;
      _this.selected.Specs.forEach(function (element, index) {
        if (parseInt(element.Stock) !== 0) {
          _this.hasstock = true;
        }
      });
    },
    getSelectedData() {
      var _this = this;
      this.alldatas.Colors.forEach(function (element, index) {
        if (element.ID === _this.selectedID) {
          _this.selected = element;
        }
      });
    },
    closeSelf() {
      this.isopen = false;
      this.btnReset();
      this.clearSpec();
    },
    selectSpec(spec) {
      this.selectedSpec = spec;
      this.selectedSpecID = spec.ID;
      this.selectedSpecKey = spec.Key;
      this.resetCounter();
      this.btnActive(spec.Stock, spec.IsOutOfStock, spec.PreOrder);
    },
    clearSpec() {
      this.selectedSpec = null;
      this.selectedSpecID = null;
      this.selectedSpecKey = null;
    },
    addCount(maxCount) {
      if (this.counter >= maxCount || this.counter >= 20) return;
      this.counter += 1;
    },
    reduceCount() {
      if (this.counter <= 1) return;
      this.counter -= 1;
    },
    resetCounter() {
      this.counter = 1;
    },
    changeImg(colorID) {
      if (this.selected.ID === colorID) return;
      this.btnReset();
      this.clearSpec();
      this.resetCounter();
      this.selectedID = colorID;
    },
    btnActive(stock, isSoldOut, isPreOrder) {
      if (this.alldatas.IsPreShow) return;
      if (stock === 0 && isSoldOut && !isPreOrder) {
        // 現貨無庫存且斷貨
        this.btnStyleGenerate = 'disabled';
        this.btnDescriptionGenerate = this.btndescription.soldout;
      } else if (stock === 0 && !isPreOrder) {
        // 現貨無庫存
        this.btnStyleGenerate = 'active-mail';
        this.btnDescriptionGenerate = this.btndescription.notice;
      } else if (stock === 0 && isPreOrder) {
        // 預購無庫存
        this.btnStyleGenerate = 'active-mail';
        this.btnDescriptionGenerate = this.btndescription.notice;
      } else {
        this.btnStyleGenerate = 'active';
        this.btnDescriptionGenerate = this.btndescription.addbag;
      }
    },
    btnReset() {
      this.btnStyleGenerate = 'disabled';
      this.btnDescriptionGenerate = this.btndescription.genernal;
    },
    addToCart() {
      const custommarketid = this.alldatas.CustomMarketID;
      const itemSpecInfo = `${custommarketid.substring(0, custommarketid.indexOf('CL'))}CL${
        this.selectedID
      }SZ${this.selectedSpecKey}`;

      this.itemSpecInfo = itemSpecInfo;

      if (this.alldatas.IsPreShow) return;

      if (this.selectedSpec === null) {
        AlertDialog.alert('請選擇尺寸');
        return;
      }

      if (this.selectedSpec.Stock === 0) {
        return;
      }

      if (this.selectedSpec.Stock === 0 && this.isnotice) {
        return;
      }

      axios
        .post(API_URL.SHOPPING_CART, {
          CustomMarketID: itemSpecInfo,
          Count: this.counter,
          UtmTag: utmKDetect(itemSpecInfo) === null ? null : utmKDetect(itemSpecInfo),
        })
        .then((res) => {
          if (res.data.Code === 200 || res.data.Code === 406) {
            this.checkisopen = false;

            messageBox.cart('加入購物車');

            this.getCartInfo();

            gtmTrace.addToCart({
              name: this.alldatas.Name,
              id: itemSpecInfo,
              price: this.alldatas.OriginPrice,
              sale_price:
                this.alldatas.EventPrice > 0 && this.alldatas.EventPrice < this.alldatas.SellPrice
                  ? this.alldatas.EventPrice
                  : this.alldatas.SellPrice,
              img_url: this.selected.Images[0].Url,
              product_url: this.selected.MarketUrl,
              color: this.selected.Name,
              count: this.counter,
            });

            fireAddToCart({
              item_id: itemSpecInfo.split('SZ')[0],
              item_name: this.alldatas.Name,
              index: 0,
              affiliation: this.selected.Name,
              item_brand: this.selectedSpec.Name,
              item_list_name: '會員收藏清單',
              price:
                this.alldatas.EventPrice > 0 && this.alldatas.EventPrice < this.alldatas.SellPrice
                  ? this.alldatas.EventPrice
                  : this.alldatas.SellPrice,
              quantity: this.counter,
              item_variant: this.selectedSpec.Barcode,
            });
          } else if (res.data.Code === 205) {
            AlertDialog.alert('商品已售完', () => {
              window.location.reload();
            });
          } else {
            AlertDialog.alert(res.data.Message);
          }
        })
        .catch((error) => {
          AlertDialog.alert(error);
        });
    },
    itemCheck(val) {
      this.checkisopen = val;
    },
  },
};
